module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.37.54.d6591d7c.png";